import CardCommon from '@op/components/CardCommon';
import React, { useState } from 'react';
import MemeTrendFilter from '../MemeTrend/MemeTrendFilter';
import SelectDropdown from '@opm/components/SelectDropdown';
import MemeKolCardWrapper from './MemeKolCardWrapper';
import MemeVideoWrapper from './MemeVideoWrapper';
import useIntls from '@opm/hooks/useIntls';
import { NO_DATE } from '@op/constants';

const dropdownOptions = [
  { key: 'followers', labelId: 'Followers' },
  { key: 'likes', labelId: 'Likes' },
];

export default function MemeDetailsWrapper({
  filter,
  wholePageRef,
  selectedDate,
}: {
  filter: any;
  wholePageRef: React.RefObject<HTMLDivElement>;
  selectedDate?: string;
}) {
  const { intl } = useIntls();
  const [dropdownValue, setDropdownValue] = useState<string>('followers');
  const [selectedKol, setSelectedKol] = useState<Array<any>>([]);

  return (
    <CardCommon
      title={(
        <>
          {intl('Meme Details')}
          {
            selectedDate && (
              <span className='dbom-meme-details-subtitle'>
                ({selectedDate})
              </span>
            )
          }
        </>
      )}
      // subFilterBeforeElement={
      //   <>
      //     <SelectDropdown
      //       value={dropdownValue}
      //       onChange={setDropdownValue}
      //       options={dropdownOptions}
      //       appearance="link"
      //       className="details-dropdown-filter"
      //       customButton={
      //         <div className="select-button">
      //           <span className="dbo-select-flex">
      //             {intl(
      //               {
      //                 id: 'KOLs Sort by {value}',
      //               },
      //               {
      //                 value: intl(
      //                   dropdownOptions?.find(
      //                     (val) => val.key === dropdownValue,
      //                   )?.labelId || NO_DATE.EMPTY,
      //                 ),
      //               },
      //             )}
      //           </span>
      //         </div>
      //       }
      //     />
      //   </>
      // }
      className="dbom-meme-details-wrapper"
    >
      {/* <MemeKolCardWrapper
        detailsFilter={filter}
        dropdownValue={dropdownValue}
        selectedKol={selectedKol}
        setSelectedKol={(kol: { anchor_uid: string }) =>
          setSelectedKol((prev) => {
            const exists = prev.find(
              (item) => item.anchor_uid === kol.anchor_uid,
            );
            if (exists) {
              return [];
            }
            return [kol];
          })
        }
      /> */}
      <MemeVideoWrapper
        detailsFilter={filter}
        selectedKol={selectedKol}
        setSelectedKol={setSelectedKol}
        wholePageRef={wholePageRef}
        selectedDate={selectedDate}
      />
    </CardCommon>
  );
}
